import rp from "@reporting/rp-app-host";
import { NodeSource, SerializedValue, TreeAdapter, TreeAdapterParams, TreeOptions, TreeSource } from "@omegagrid/tree";
import { ModuleCode } from "@reporting/rp-types/accounting";

export class DimAttributeTreeAdapter extends TreeAdapter {

	constructor(
		private module: ModuleCode,
		private dimNum: string,
		private attrKey: string,
		private options?: Partial<TreeOptions>
	) { super() }

	async getTree(params: TreeAdapterParams): Promise<TreeSource> {
		const response = await rp.ms('analytics').get<{v: string}[]>(`dimensionAttributes/${this.module}/${this.dimNum}/${this.attrKey}`);
		return response.map(item => ({
			k: item.v,
			v: item.v,
			l: 0,
		}));
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || {};
	}

}
